export class DialogModelConfirmCheck {
    constructor(
        public message: any,
        public acceptButtonName: any,
        public denyButtonName: any  
    ) {}
  }
  